import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import { FC } from "react";

import { VideoCarousel as VideoCarouselImpl, VimeoPlayer } from "@up/ui";

import { ClientErrorBoundary } from "../../components/ClientErrorBoundary";
import RichText from "../../components/RichText";
import Wrapper from "../../components/SliceWrapper";

/**
 * Props for `VideoCarousel`.
 */
export type VideoCarouselProps =
  SliceComponentProps<Content.VideoCarouselSlice>;

function carouselHidden(videos: any[]) {
  if (videos.length === 0) return "hidden";
  if (videos.length === 1 && videos[0].hidden) return "hidden";
  return "";
}

/**
 * Component for "VideoCarousel" Slices.
 */
const VideoCarousel: FC<VideoCarouselProps> = ({ slice }) => {
  return (
    <ClientErrorBoundary message="Carousel slice error boundary">
      {/* @ts-expect-error — SliceWrapper is an untyped JS component */}
      <Wrapper
        slice={slice}
        data-analytics-component="video-carousel"
        wrapperClass={`video-carousel-wrapper ${carouselHidden(slice.primary.videos)}`}
      >
        <div className="rte section-heading">
          <RichText field={slice.primary.heading} />
        </div>
        {slice.primary.videos.length ? (
          <VideoCarouselImpl
            theme="white"
            videos={slice.primary.videos}
            VideoPlayerComponent={VimeoPlayer}
          />
        ) : null}
      </Wrapper>
    </ClientErrorBoundary>
  );
};

export default VideoCarousel;
